<template>
  <div>
    <email-to-taiko-dialog v-model="showEmailToTaikoDialog" />

    <v-dialog v-model="show" max-width="800px" persistent scrollable>
      <v-card id="terms-dialog-card">
        <v-card-title
          v-if="type === 'buyer'"
          class="headline grey lighten-2"
          primary-title
          v-text="$t('MENU.TERMS')"
        />

        <v-card-text v-if="type === 'buyer'">
          <div style="min-height: 200px" :class="{'loading': loading}">
            <tk-froala :content="terms.terms" />
          </div>
        </v-card-text>

        <v-card-text v-else>
          <div :class="{'loading': loading}">
            <div v-if="terms.legal">
              <h1>{{ $t('COMMON.LEGAL_AGREEMENT')}}</h1>
              <div style="min-height: 200px">
                <tk-froala :content="terms.legal" />
              </div>
            </div>

            <div v-if="terms.terms">
              <h1 class="mt-4">{{ $t('MENU.TERMS')}}</h1>
              <div style="min-height: 200px">
                <tk-froala :content="terms.terms" />
              </div>
            </div>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <tk-btn flat @click="onDisagree">{{ $t('COMMON.I_DISAGREE') }}</tk-btn>
          <tk-btn
            :disabled="loading"
            :loading="saving"
            autofocus
            color="primary"
            @click="accept"
          >{{ $t('COMMON.I_AGREE') }}</tk-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>



<script>
import { ErrorHandler } from "@/utils/ErrorHandler";
import EmailToTaikoDialog from "./EmailToTaikoDialog.vue";
import TkFroala from "@/components/core/TkFroala.vue";

const handler = new ErrorHandler();

export default {
  props: {
    show: {
      type: Boolean,
      required: true,
    },
    type: {
      type: String,
      required: true,
    },
    update: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    EmailToTaikoDialog,
    TkFroala,
  },

  data() {
    return {
      terms: {},
      loading: false,
      saving: false,
      showEmailToTaikoDialog: false,
    };
  },

  watch: {
    show: "fetchData",
  },

  methods: {
    async fetchData() {
      if (!this.show) return;

      this.loading = true;
      this.terms = {};
      await handler.handle(async () => {
        const res = await this.$axios.get(`latest-terms?type=${this.type}`);
        this.terms = res.data.data;
      });
      this.loading = false;
    },

    async accept() {
      if (this.update) {
        this.saving = true;
        const payload = {
          term_id: this.terms.id,
          is_accepted: true,
        };
        await this.$auth.submitNewTerms(this.$auth.currentUser.id, payload);
        await this.$auth.refresh();
      }
      this.saving = false;

      this.$emit("close", this.terms.id);
    },

    onDisagree() {
      this.$emit("close", false);
      this.showEmailToTaikoDialog = true;
    },
  },
};
</script>
